import { CatInlineNotification } from '@blocks-react/components/InlineNotification';
import { MyEquipmentWarningProps } from '../types';

export const MyEquipmentWarning = ({
  children,
  errorNote,
  variant
}: MyEquipmentWarningProps) => {
  return (
    <CatInlineNotification heading={errorNote} variant={variant}>
      {children}
    </CatInlineNotification>
  );
};
